import "../css/App.css";
import "../css/FullEvent/FullEvent.css";
import { memo } from "react";
import { AccountData } from "@markit/common.types";
import { Icon } from "@iconify/react";
import { useTheme } from "../hooks/useTheme";

type CreatorTextManualProp = {
  host: AccountData;
};

const CreatorTextManual = memo(function CreatorTextManualFn(
  props: CreatorTextManualProp
) {
  const { host } = props;
  const { theme } = useTheme();

  const styles = {
    itemContainer: {
      gap: 14,
      paddingRight: 24,
    },
  };

  return (
    <div className="ColumnNormal" style={{ gap: 14 }}>
      <div className="AlignedRow" style={styles.itemContainer}>
        <div>
          <Icon icon="ion:person-add" height={26} style={theme.PrimaryText} />
        </div>
        <span className="bodySubtext">
          Get notified about exclusive content, updates, products, and more!
        </span>
      </div>
      <div className="AlignedRow" style={styles.itemContainer}>
        <div>
          <Icon icon="ion:chatbubbles" height={26} style={theme.PrimaryText} />
        </div>
        <span className="bodySubtext">
          Chat with {host.fullName} directly through text from your phone&apos;s
          messaging app.
        </span>
      </div>
      <div className="AlignedRow" style={styles.itemContainer}>
        <div>
          <Icon icon="ion:stop-circle" height={26} style={theme.PrimaryText} />
        </div>
        <span className="bodySubtext">
          Reply STOP at any time to unsubscribe.
        </span>
      </div>
    </div>
  );
});

export default CreatorTextManual;
